import Component from './Component'

export default class Map extends Component {

	static _type = 'Map'

	_name
	_list
	_leaflet
	_leaflet_markers = []
	_leaflet_mcg
	map
	filter_regex = null
	search_fields = []
	sort_order = []

	constructor (name, list, search_fields, params = {}) {
		super(params)
		this._name = name
		this._list = list
		this.search_fields = search_fields
	}

	tether () {
		super.tether()

		// Init leaflet
		this._leaflet = L.map(`${this.name}_map_frame`).setView([ 47.175, 19.485 ], 8)

		// Init tileset for the map
		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
		    maxZoom: 19,
		    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		}).addTo(this._leaflet)

		// Begin the preprocessor
		this.preprocess()
	}

	get name () { return this._name }

	get list () { return this._list }
	set list (value) {
		this._list = value

		// Begin the preprocessor
		this.preprocess()
	}

	// Preprocess
	preprocess () {

		// Begin component update with filter step
		this.filter()
	}

	// Update: step 1
	filter (expression = null) {

		// If we get a new expression, let's prepare it first
		if (expression !== null) {

			// Sanitize
			expression = (expression + '').trim()

			// Convert to regexp
			if (expression == '') {
				// Empty expression
				this.filter_regex = null
			} else {
				// Useful expression
				let exp = ''
				for (let char of expression) {
					// Multi-char substitution
					if (char == '*') {
						exp += '.{1,}'
						continue
					}
					// Single-char substitution
					if (char == '?') {
						exp += '.'
						continue
					}
					// Regex special characters
					if (['\\', '^', '$', '.', '|', '?', '*', '+', '(', ')', '[', ']', '{', '}'].includes(char)) {
						exp += '\\' + char
						continue
					}
					// Everything else
					exp += char
				}

				this.filter_regex = new RegExp(exp, 'gmi')
			}
		}

		// Apply filter
		if (this.filter_regex === null) {
			// We have no filter regex, just clone the reference array
			this.map = this._list.data.map(x => x)
		} else {
			// Create a filtered reference array
			this.map = this._list.data.filter((row) => {
				// For every row..
				for (let field of this.search_fields) {
					// Check every field for a match
					if (this.filter_regex.test(row[field] + ''))
						// We found a match in this field
						return true
				}

				// No matches in this row
				return false
			})
		}

		// Continue update with content render
		this.render()
	}

	/* Update: step 2
	 * Re-render the map.
	 */
	async render () {

		// Clear all markers
		this._leaflet_markers = []
		if (this._leaflet_mcg) {
			this._leaflet.removeLayer(this._leaflet_mcg)
		}
		this._leaflet_mcg = L.markerClusterGroup({
			showCoverageOnHover: false,
			animate: false,
			maxClusterRadius: 40,
			iconCreateFunction: function(cluster) {
				return L.divIcon({
					html: '<b>' + cluster.getChildCount() + '</b>'
				});
			}
		})

		// Prepare markers
		for (const element of this.map) {
			if ('geo_coords' in element && Array.isArray(element.geo_coords)) {
				var marker_style = undefined
				if ('styles' in this.params && 'style_field' in this.params && this.params.style_field) {
					const style = this.params.styles.find(s => s.value == element[this.params.style_field])
					marker_style = {
						icon: L.AwesomeMarkers.icon({
							icon: style.icon,
							markerColor: 'orange',
							prefix: 'fa',
							extraClasses: 'mt-2 pt-1'
						})
					}
				}
				const marker = L.marker(element.geo_coords, marker_style)
				if ('popup_template' in this.params && this.params.popup_template) {
					const popup_content = await Anvil.render(this.params.popup_template, element, '')
					marker.bindPopup(popup_content)
				}
				if ('tooltip_field' in this.params && this.params.tooltip_field) {
					marker.bindTooltip(element[this.params.tooltip_field])
				}
				this._leaflet_markers.push(marker)
			}
		}

		// Add markers (bulk)
		this._leaflet_mcg.addLayers(this._leaflet_markers)
		this._leaflet.addLayer(this._leaflet_mcg)

		// Redraw list view
		if ('list_template' in this.params) {
			Anvil.render(this.params.list_template, { data: this.map }, `#${this.name}_map_list`)
		}
	}

	destroy () {

		this._list = null

		super.destroy()
	}
}
